import { b2x } from '@b2x/react/src';
import React from 'react';

import { ComponentWrapper } from './ComponentWrapper';
import { MultiColumnAContentType } from './contentTypes';

export const MultiColumnA = ({ columns, header, options }: MultiColumnAContentType) => {
  const _headingType = header?.headingType as string;

  return (
    <ComponentWrapper classNames="multi-column-a" options={options}>
      {header && (
        <b2x.Div className="mb-lg-5 mb-4" textAlign={'center'}>
          <b2x.Row justifyContent={'center'}>
            <b2x.Col size={{ lg: 6, xs: 12 }}>
              {React.createElement(_headingType, { class: 'h1 m-0' }, header.title?.toUpperCase())}
            </b2x.Col>
          </b2x.Row>
        </b2x.Div>
      )}
      {columns && columns.length > 0 && (
        <b2x.Row gap={3} justifyContent={'center'}>
          {columns.map((column) => (
            <b2x.Col key={column.contentSectionId} size={{ lg: 5, md: 6, xs: 12 }}>
              <b2x.AssetV2 {...column.asset} fluid />
            </b2x.Col>
          ))}
        </b2x.Row>
      )}
    </ComponentWrapper>
  );
};
